import { ChainId, Token } from '@noahswap/sdk'
import { EUSD_TESTNET, NOAH_TESTNET } from './common'

export const evmTestnetTokens = {
  noah: NOAH_TESTNET,
  eusd: EUSD_TESTNET,
}
